module.exports = __webpack_public_path__ + "static/media/IMG_4877.ca8f2d73.JPG";